import type { SagGame } from '@ps/poker-games-tile-mappers';

export enum GameType {
  Holdem = 'Holdem',
  HoldemMax = 'HoldemMax',
  HoldemFlash = 'HoldemFlash',
  Omaha = 'Omaha'
}

export type GameTypeName = keyof typeof GameType;

export type Game = SagGame;

export interface GameHoldem extends Game {
  isMax: false;
  isFlash: false;
  game: 'Holdem';
}

export interface GameFlash extends Game {
  isFlash: true;
  game: 'Holdem';
}

export interface GameMax extends Game {
  isMax: true;
  game: 'Holdem';
}
export interface GameOmaha extends Game {
  isMax: false;
  isFlash: false;
  game: 'Omaha';
}

export interface GameTypeUrl {
  holdem: string;
  flash: string;
  omaha: string;
  max: string;
}

type GameTypeUrlKey = keyof GameTypeUrl;

export enum GameStake {
  MICRO = 'stake-micro', // 0.25 - 5
  LOW = 'stake-low', // 5.01 - 24.99
  MEDIUM = 'stake-medium', // 25-99.99
  HIGH = 'stake-high', // 100+
  ULTRA = 'stake-ultra' // 1M promo
}

export const GAME_TYPE_URL_MAP: { [key in GameType]: GameTypeUrlKey } = {
  Holdem: 'holdem',
  HoldemMax: 'max',
  HoldemFlash: 'flash',
  Omaha: 'omaha'
};
